import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, mount = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const show = mount || inView;
  return (
    <span ref={ref} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={`${line}-${i}`} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={show ? { y: "0%" } : { y: "115%" }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const Overline = ({ children, light = false, className = "" }) => (
  <p
    className={`text-[11px] uppercase tracking-[0.35em] font-mono ${
      light ? "text-[#DFCA9B]" : "text-[#C5A059]"
    } ${className}`}
  >
    {children}
  </p>
);

export const Marquee = ({ items }) => {
  const content = items.map((item, i) => (
    <span key={`${item}-${i}`} className="flex shrink-0 items-center">
      <span className="font-serif text-2xl md:text-4xl font-light italic text-[#1C1C1A]/35 whitespace-nowrap">
        {item}
      </span>
      <span className="mx-8 md:mx-12 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[#C5A059]/60" />
    </span>
  ));
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden border-y border-[#1C1C1A]/10 py-6 md:py-8"
    >
      <div className="marquee-track flex w-max">
        <div className="flex shrink-0 items-center">{content}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {content}
        </div>
      </div>
    </div>
  );
};
